export default "__VITE_ASSET__kiBoSSB___"